import React from 'react';
import * as echarts from 'echarts';
import EchartsReactCore from './core';

// import data from './theme.json'

// export the Component the echarts Object.
const EchartsReact = (props) => {
  // Register theme if needed
  // echarts.registerTheme('customed', data)

  const echartsLib = echarts;

return (
    <EchartsReactCore echartsLib={echartsLib} {...props}/>
  );
};

export default EchartsReact;